/** @jsx jsx */
import React from 'react';
import { isIPad13 } from "react-device-detect";
import { css, jsx, SerializedStyles } from '@emotion/core';
import productColor from 'components/styles';
import { GroupMenu } from 'components/templates/menuData';
import { Link } from "react-router-dom";
import { checkBoxMenu, checkBoxGroupMenu } from 'components/templates/Sidebar';
import { useLocation } from 'react-router-dom';
import BodyText from "components/atoms/BodyText";
import Icon from 'components/atoms/Icon';
const isIpad = window.matchMedia("(max-width: 1024px)").matches;

const styles = {
  breadCrumb: css({
    right: '0px',
    zIndex: 3,
    top: '20px'
  }),
  homeLink: {
    color : productColor.primary,
    textDecoration: 'none',
    fontSize: '12px'
  }
};

const getBreadCrumb = (menu: Array<GroupMenu>, group: string) => {
  let breadList = [];

  let groupMenu = menu.filter((menuItem) => 
    checkBoxGroupMenu(menuItem, group)    
  )[0];

  if(groupMenu) {
    breadList.push(groupMenu?.display || "");

    groupMenu.menuList?.map((item, index) => {
      if(checkBoxMenu(item, group)) {
        breadList.push(item.display);

        if(item.subMenu) {
          breadList.push(item.subMenu.filter((i) => i.value === group)[0].display);
        }
      }
    });
  }

  return breadList;
};

const BreadCrumb: React.FC<{
  menu: Array<GroupMenu>;
  customStyle?: SerializedStyles;
}> = ({menu, customStyle}) => {
  const location = useLocation();

  let group1 = location.pathname.split('/')[1] || 'agreement36';
  let group2 = location.pathname.split('/')[2] || 'agreement36';
  return (
    <div css={[styles.breadCrumb, customStyle]}>
      <Link to="/agreement36" style={styles.homeLink}>
        <Icon 
          type={'house'} 
          color={productColor.primary} 
          size="10px" 
          margin="0 5px 0 0" 
          verticalAlign="unset"
        />
        Top
      </Link>
      {
        group1 !== 'recorder' ? getBreadCrumb(menu, group1).map((breadItem: string, index: number, arr: Array<string>) => (
          <React.Fragment>
            <Icon 
              type={"chevronMenu"}
              color="#666" 
              size="10px" 
              verticalAlign="middle"
              margin={`${isIpad}` ? "4px" : "10px"}
            />
            <BodyText color="#666" size="sm">{breadItem}</BodyText>
          </React.Fragment>
        ))
        : getBreadCrumb(menu, group2).map((breadItem: string, index: number, arr: Array<string>) => (
          <React.Fragment>
            <Icon 
              type={"chevronMenu"}
              color="#666" 
              size="10px" 
              verticalAlign="middle"
              margin={`${isIpad}` ? "4px" : "10px"}
            />
            <BodyText color="#666" size="sm">{breadItem}</BodyText>
          </React.Fragment>
        ))
      }
    </div>
  );
};

export default BreadCrumb;
